export const helpLink = 'https://www.solve.finance/resources/faq/';
export const FRANKLIN_APP_URL = 'https://app.franklincredit.com';
